import { Box, Container, Text } from '@chakra-ui/react';
import { SeparatorHelper } from '../general/separator';

export const PhilosphyPage = () => {
  return (
    <>
      <Container maxW="3xl" bg="#e3e6e8" pb={10}>
        <Box mb={6} id="philosophy">
          <Text
            fontSize={{ base: '2xl', sm: '2xl', md: '2xl', lg: '3xl' }}
            pt={{ base: 4, md: 7 }}
            textAlign="center"
            fontFamily="'Bad Script', cursive"
          >
            The Philosophy{' '}
          </Text>
        </Box>
        <Box textAlign="left" mb={4}>
          <Text mx="auto" opacity={0.95} lineHeight="1.6">
            The philosophy behind Fernsology is simple: Findings and
            Perspectives.
          </Text>
        </Box>

        <Box textAlign="left" pt={4}>
          <Text textStyle="xl" mx="auto" opacity={0.95} lineHeight="1.6">
            Findings
          </Text>
        </Box>

        <SeparatorHelper />

        <Text
          mx="auto"
          opacity={0.95}
          lineHeight="1.6"
          justifyItems="left"
          justifyContent="center"
        >
          Findings at Fernsology are about more than just writing - they’re
          about discovering. Every article combines research and smart
          methodologies, and is presented clearly, grounded in certain results
          and benchmarks.
        </Text>
        <Box textAlign="left" pt={4}>
          <Text textStyle="xl" mx="auto" opacity={0.95} lineHeight="1.6">
            Perspectives
          </Text>
        </Box>

        <SeparatorHelper />
        <Text
          mx="auto"
          opacity={0.95}
          lineHeight="1.6"
          justifyItems="left"
          justifyContent="center"
        >
          Perspective represents the point of view of the person who conducted
          the research and wrote the findings. It is vital, much like language
          translation, in breaking barriers and making information accessible.{' '}
          <br />
          Perspective shapes how we interpret, understand, and communicate
          knowledge. Since context can be subjective and there are multiple
          angles to any insight, Fernsology ensures that every article is
          presented in a way that allows readers to draw meaningful conclusions
          and make informed decisions.
        </Text>

        <Box textAlign="left" pt={4}>
          <Text textStyle="xl" mx="auto" opacity={0.95} lineHeight="1.6">
            The Point
          </Text>
        </Box>

        <SeparatorHelper />
        <Text
          mx="auto"
          opacity={0.95}
          lineHeight="1.6"
          justifyItems="left"
          justifyContent="center"
        >
          The point of these values are simple: <b>findings</b> ensure that
          everything we share is well-grounded in evidence, while{' '}
          <b>perspectives</b> gives voice and context to those findings. These
          values are what makes sense to Fernsology - to guide understanding,
          interpretation, and meaningful action. Nothing more, nothing less!
        </Text>
      </Container>
    </>
  );
};
